import type { ReactNode } from "react";

/** Scrollable list body for dashboard cards with many rows. */
export function DashboardScrollableList({ children }: { children: ReactNode }) {
    return <div className="min-h-0 flex-1 overflow-y-auto overscroll-y-contain">{children}</div>;
}
